import type { AccessConstraint } from '@sb/shared/access';
import { featureFlag } from '@sb/shared/feature';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the employees routes. */
export const employeesAccess = {
  employees: { permission: 'View all users' },
  templates: {
    permission: 'Manage contract templates',
    subscriptionPlan: PlanType.BASIC,
    featureFlag: featureFlag.TMP_CONTRACT_TEMPLATE,
  },
  extension: {
    permission: 'Create contracts',
    subscriptionPlan: PlanType.BASIC,
    featureFlag: featureFlag.TMP_CONTRACT_EXTENSION,
  },
  absence: { permission: 'View absentee' },
} satisfies Record<string, AccessConstraint>;
